'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.linearLength = undefined;

var _decurve = require('./decurve');

var _decurve2 = _interopRequireDefault(_decurve);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var length = function length(shape, accuracy) {
  var s = (0, _decurve2.default)(shape, accuracy);

  return s.reduce(function (currentLength, _ref, i) {
    var x2 = _ref.x;
    var y2 = _ref.y;
    var moveTo = _ref.moveTo;

    if (!moveTo) {
      var _s = s[i - 1];
      var x1 = _s.x;
      var y1 = _s.y;

      currentLength += linearLength(x1, y1, x2, y2);
    }

    return currentLength;
  }, 0);
};

var linearLength = function linearLength(x1, y1, x2, y2) {
  return Math.sqrt(Math.pow(x1 - x2, 2) + Math.pow(y1 - y2, 2));
};

exports.linearLength = linearLength;
exports.default = length;